import { Component } from '@angular/core';
import { NavController,  ViewController, Config,} from 'ionic-angular';

import { UserMyRadiant as User, PermitProvider, Me, HelperMyRadiant, LoginMyRadiant } from '../../providers';
import { Nav, NavParams, MenuController, Events, } from 'ionic-angular';
import { RepositoryMyRadiant } from '../../providers';
import swal from "sweetalert";

@Component({
  selector: 'change-password-page',
  templateUrl: 'page.html'
})
export class ChangePasswordPage {
  loading : any;
  state = {
    current_password:true,
    new_password:true,
    confirm_new_password:true,
  };

  parameter = {
    id:this.userApi.data.Employee_ID,
    code:this.userApi.data.NIK,
    name:this.userApi.data.Nama_Karyawan,
    current_password:null,
    new_password:null,
    confirm_new_password:null,
  };
  user:any = {};

  
  
  constructor(
    public navCtrl            : NavController,
    public userApi            : User,
    public menuCtrl           : MenuController,
    public nav                : Nav,
    public navParams          : NavParams,
    public repositoryProvider : RepositoryMyRadiant,
    public activityProvider   : Me,
    public viewCtrl           : ViewController,
    public events             : Events,
    public config             : Config,
    public helper             : HelperMyRadiant,
    public loginProvider      : LoginMyRadiant,
    ) {
    this.config.set('backButtonText',"Change Password");
    this.user.username = '';
    this.user.password = '';
  }

  ionViewWillLeave(){
   this.config.set('backButtonText','');
  }

  showPassword(input,cmp,state) {  
    this.state[state] = !this.state[state];
  	input.type = input.type === 'password' ? 'text' : 'password';
  	input.setFocus();
  	console.log(cmp);
  }
  
  cancel(){
    this.viewCtrl.dismiss();
  }

  checkingInput(){
    let out = {
      condition:true,
      msg:'valid'
    }
    console.log(this.parameter);
    if (this.parameter.current_password == "" || this.parameter.new_password == "" || this.parameter.confirm_new_password == "" || this.parameter.current_password == null || this.parameter.new_password == null || this.parameter.confirm_new_password == null) {
      out.condition = false;
      out.msg = "You must complete all forms";
    }else if (this.parameter.new_password != this.parameter.confirm_new_password) {
      out.condition = false;
      out.msg = "New passwords are not the same";
    }
    return out;
  }

  changePassword(){
    let me = this;
    let check = this.checkingInput();
    console.log(check);
    if (!check.condition) {
      this.helper.presentToast(check.msg);
    }else{
     let optionsSwal = {
        title:"Are you sure?",
        desc:"Old passwords cannot be used anymore.",
        icon:"",
        dangerMode:false,
        btnCancel:"Cancel",
        btnConfirm:"Yes",
      }
     this.helper.presentSwalConfirmation(optionsSwal,() => {
      me.loading = me.helper.showLoading("Please Wait...");
      me.loginProvider.changePassword(this.parameter).subscribe((resp:any) => {
        try {
          this.loading.dismiss();
        } catch (error) {
          
        }
        if(resp.success){
          me.helper.presentToast("Success Change Your Password. You will logout automatically.");
          me.viewCtrl.dismiss();
          setTimeout(() => {
            this.events.publish('user:want_sign_out');
          }, 2000);
        }else{
          me.helper.presentToast(resp.msg);
        }
      },(err) => {
        try {
          me.loading.dismiss();
        } catch (error) {
          
        }
      });
     })
    }
  }

  proses
}



// WEBPACK FOOTER //
// ./src/pages/changePassword/page.ts